/* RAGANA — Footer interactions JS
   Toggle disclaimer accordion
*/
(function () {
  const toggle = document.querySelector('.rg-ft__disclaimer-toggle');
  const panel  = document.querySelector('.rg-ft__disclaimer');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function () {
    const isOpen = panel.classList.contains('open');
    panel.classList.toggle('open', !isOpen);
    toggle.classList.toggle('open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });
}());